import { useEffect, useRef, useState } from "react";
import { BrowserMultiFormatReader } from "@zxing/library";

export default function BarcodeScanner({ onScan, onClose }) {
  const videoRef = useRef(null);
  const readerRef = useRef(null);
  const [error, setError] = useState("");
  const [scanning, setScanning] = useState(true);

  useEffect(() => {
    const codeReader = new BrowserMultiFormatReader();
    readerRef.current = codeReader;

    codeReader.decodeFromVideoDevice(null, videoRef.current, (result, err) => {
      if (result && scanning) {
        setScanning(false);
        onScan(result.getText());
      }
    });

    return () => {
      codeReader.reset();
    };
  }, []);

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.95)",
      zIndex: 2000, display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center"
    }}>
      {/* Header */}
      <div style={{
        position: "absolute", top: 0, left: 0, right: 0,
        padding: "16px 24px", display: "flex",
        justifyContent: "space-between", alignItems: "center"
      }}>
        <div style={{ color: "#fff", fontWeight: 700, fontSize: 18 }}>
          📷 Scan Barcode
        </div>
        <button onClick={onClose} style={{
          background: "rgba(255,255,255,0.2)", border: "none",
          color: "#fff", padding: "8px 16px", borderRadius: 8,
          cursor: "pointer", fontWeight: 600
        }}>✕ Close</button>
      </div>

      {/* Camera View */}
      <div style={{ position: "relative", width: "100%", maxWidth: 400 }}>
        <video ref={videoRef} style={{
          width: "100%", borderRadius: 12,
          display: "block"
        }} />
        {/* Scanning overlay */}
        <div style={{
          position: "absolute", inset: 0,
          border: "2px solid rgba(255,255,255,0.3)",
          borderRadius: 12, pointerEvents: "none"
        }}>
          {/* Corner markers */}
          {[
            { top: 16, left: 16, borderTop: "3px solid #2d7a4f", borderLeft: "3px solid #2d7a4f" },
            { top: 16, right: 16, borderTop: "3px solid #2d7a4f", borderRight: "3px solid #2d7a4f" },
            { bottom: 16, left: 16, borderBottom: "3px solid #2d7a4f", borderLeft: "3px solid #2d7a4f" },
            { bottom: 16, right: 16, borderBottom: "3px solid #2d7a4f", borderRight: "3px solid #2d7a4f" }
          ].map((style, i) => (
            <div key={i} style={{
              position: "absolute", width: 24, height: 24, ...style
            }} />
          ))}
          {/* Scanning line animation */}
          <div style={{
            position: "absolute", left: 16, right: 16, height: 2,
            background: "linear-gradient(90deg, transparent, #2d7a4f, transparent)",
            animation: "scanLine 2s ease-in-out infinite",
            top: "50%"
          }} />
        </div>
      </div>

      {/* Instructions */}
      <div style={{
        color: "rgba(255,255,255,0.8)", fontSize: 14,
        marginTop: 24, textAlign: "center", padding: "0 32px"
      }}>
        Point camera at the barcode on the product packaging
      </div>

      {error && (
        <div style={{
          color: "#ef4444", fontSize: 13,
          marginTop: 12, textAlign: "center"
        }}>{error}</div>
      )}

      <style>{`
        @keyframes scanLine {
          0% { top: 20%; }
          50% { top: 80%; }
          100% { top: 20%; }
        }
      `}</style>
    </div>
  );
}